/* tslint:disable:typedef-whitespace align no-trailing-whitespace */

import { Router                } from '@angular/router';
import { AuthenticationService } from '@/services/authentication.service';
import { Action, ActionType    } from '@/models/action';
import { User                  } from '@/models/user';
import { Logger                } from '@/util/logger';

/**
 *
 * @class AdminUsersAction
 *
 * @brief navigation action - go to the user directory page
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2020
 *
 */
export class AdminUsersAction extends Action {

  private auth: AuthenticationService = null;

  constructor(
    private router:  Router,
           options: any = null
  ) {

    super({
      key:   'admin.users',
      type:  ActionType.Admin_Users,
      label: 'User Directory',
      icon:  '<i class="fas fa-users"></i>',
      tip:   'Manage users'
    });

    this.auth     = this.injector().get(AuthenticationService);
  }

  /* is this action enabled? */
  public enabled(): boolean {

    /* only enabled if this user is an administrator */

    const currentUser: User = this.auth.userOfSession;

    if (currentUser) {

      if (currentUser.isAdmin) {

        return true;
      }

    }

    return false;
  }

  /** implement the action */
  public execute(): boolean {

    if (!this.enabled()) {
      return false;
    }

    Logger.debug('[AdminUsersAction] jumping to users page...');

    this.router.navigate(['administration/users']);
  }
}
